import { getGridPlacement } from '@speedlo/ui/src/utils/gridUtils'
import * as React from 'react'

import { StickyGridColumn } from '~shared/components/Sticky/StickyGridColumn'
import { AddonDetail } from '~shared/segments/AddonDetail'
import { AddonList } from '~shared/segments/AddonList'
import { ModalBody } from '~ui/components/content/Modal/components/ModalBody'
import { ModalFooter } from '~ui/components/content/Modal/components/ModalFooter'
import { ModalHeader } from '~ui/components/content/Modal/components/ModalHeader'
import { Modal } from '~ui/components/content/Modal/Modal'
import { Grid, GridRow } from '~ui/components/layout/Box'
import { TSingleSpace } from '~ui/styleGuide/spaces'

import { useLayoutCtx } from '../../../config/contexts/LayoutProvider'
import { useProductDetailControlCtx } from '../contexts/ProductDetailProvider'
import { TProductDetailOverlay } from '../types'
import { ProductDetailAmountControl } from './ProductDetailAmountControl'
import { ProductDetailImage } from './ProductDetailImage'
import { ProductDetailInfo } from './ProductDetailInfo'
import { ProductDetailModalHeadline } from './ProductDetailModalHeadline'
import { ProductDetailTotal } from './ProductDetailTotal'
import { ProductNote } from './ProductNote'
import { SubmitCartItemButton } from './SubmitCartItemButton'

type TProps = NoChildren &
  TProductDetailOverlay & {
    modalBodySpacing: TSingleSpace
  }

/**
 * Overlay modal for product detail.
 */
export const ProductDetailOverlayModal: React.FC<TProps> = ({
  branchId,
  modalBodySpacing,
  cannotOrderNote,
  canCreateOrder = true,
  stuckContentHeight,
}) => {
  const { closeProductDetail } = useProductDetailControlCtx()
  const { isTablet } = useLayoutCtx()

  // TODO zIndex
  return (
    <>
      <Modal isOpen onClose={closeProductDetail} size={`lg`} overlayZIndex={100}>
        <ModalHeader shadow={`medium`} bgColor={`bgColors.company`} withCloseButton>
          <ProductDetailModalHeadline canCreateOrder={canCreateOrder} />
        </ModalHeader>

        <ModalBody padding={modalBodySpacing}>
          <Grid
            as={`section`}
            rowGap={`medium`}
            columnGap={modalBodySpacing}
            gridTemplateColumns={`auto min-content`}
            gridTemplateRows={`auto 1fr`}
            alignItems={`start`}
            minHeight={`10.25rem`}
          >
            {/* product info is not wrapped because of its sticky header on mobile that do not work otherwise */}
            <Grid rowGap={`small`}>
              <ProductDetailInfo />
            </Grid>

            {!isTablet && (
              <StickyGridColumn {...getGridPlacement({ col: 2, row: `all` })}>
                <ProductDetailImage />
              </StickyGridColumn>
            )}

            {isTablet && <ProductDetailImage />}

            <Grid {...getGridPlacement({ col: isTablet ? `all` : 1 })} rowGap={`large`}>
              <AddonList stuckContentHeight={stuckContentHeight} />
              <ProductNote canCreateOrder={canCreateOrder} />
            </Grid>
          </Grid>
        </ModalBody>

        <ModalFooter
          shadow={`medium`}
          padding={{ horizontal: modalBodySpacing, vertical: `medium` }}
        >
          <GridRow
            width={`100%`}
            columnGap={modalBodySpacing}
            alignItems={`center`}
            gridAutoColumns={`auto max-content max-content`}
          >
            {cannotOrderNote}
            <ProductDetailAmountControl canCreateOrder={canCreateOrder} />
            <ProductDetailTotal />
            <SubmitCartItemButton canCreateOrder={canCreateOrder} />
          </GridRow>
        </ModalFooter>
      </Modal>
      <AddonDetail branchId={branchId} />
    </>
  )
}
